import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { Link, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../../assets/css/Auth.css";
import ZnetLogo from "../../assets/images/PNG Logo Files/Transparent Logo NameLess.png";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // ✅ Handle Social Login (Google, Facebook, Apple)
  const handleSocialLogin = (provider) => {
    try {
      setLoading(true);
      let redirectUrl = "";

      switch (provider) {
        case "Google":
          redirectUrl = "https://api.biznetusa.com/api/auth/google/redirect";
          break;
        case "Facebook":
          redirectUrl = "https://api.biznetusa.com/api/auth/facebook/redirect";
          break;
        default:
          toast.error("Invalid provider");
          setLoading(false);
          return;
      }

      window.location.href = redirectUrl;
    } catch (error) {
      console.error("OAuth redirect failed:", error);
      toast.error("Something went wrong during social login.");
      setLoading(false);
    }
  };

  // ✅ Handle Email/Password login
  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    const formData = new URLSearchParams();
    formData.append("email", email);
    formData.append("password", password);

    try {
      const response = await fetch("https://api.biznetusa.com/api/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: formData.toString(),
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.message || "Failed to log in");

      const { access_token, token_type } = data;
      if (!access_token) throw new Error("Invalid response from server.");

      const token = `${token_type} ${access_token}`;
      localStorage.setItem("token", token);
      navigate("/Questionaire");
    } catch (error) {
      toast.error(error.message || "An unexpected error occurred.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Login - ZNet</title>
        <meta
          name="description"
          content="Log in to your ZNet account to access personalized services and features."
        />
        <meta
          name="keywords"
          content="login, authentication, user access, ZNet login, secure login"
        />
      </Helmet>

      <main className="background_color_fixed">
        <div className="d-flex align-items-center justify-content-center min-vh-100">
          <div
            className="card body_color shadow-lg p-4 mx-3"
            style={{ maxWidth: "32rem", width: "100%" }}
          >
            {/* Logo */}
            <img
              src={ZnetLogo}
              alt="Znet Logo"
              className="mx-auto"
              style={{ width: "100px" }}
            />

            {/* Tabs */}
            <div className="my-3 d-flex justify-content-center align-items-center gap-0">
              <Link
                className="btn btn-primary text-decoration-none w-50"
                style={{ flexGrow: "1", backgroundColor: `var(--background_color)` }}
                to="/Login"
              >
                <h3 className="h6 fw-semibold m-0 text-white">Sign In</h3>
              </Link>
              <Link
                className="btn btn-primary text-decoration-none w-50"
                style={{ flexGrow: "1", backgroundColor: "var(--color)" }}
                to="/SignUp"
              >
                <h3 className="h6 fw-semibold m-0 text-white">New Account</h3>
              </Link>
            </div>

            {/* Login Form */}
            <form onSubmit={handleLogin}>
              <div className="mb-3">
                <label className="form-label" htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  placeholder="Enter email"
                  className="form-control"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  disabled={loading}
                />
              </div>

              <div className="mb-3">
                <label className="form-label" htmlFor="password">Password</label>
                <input
                  type="password"
                  id="password"
                  placeholder="Enter password"
                  className="form-control"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  disabled={loading}
                />
              </div>

              <button type="submit" className="btn btn-primary w-100" disabled={loading}>
                {loading ? "Signing in..." : "Sign in"}
              </button>

              <p className="text-center mt-3">
                <a href="/ForgotPassword" className="text-decoration-underline">
                  Forgot your password?
                </a>
              </p>
            </form>

            {/* Social Login */}
            <div className="my-4 border-top text-center pt-3">
              <p>Or connect with:</p>
              <div className="d-flex flex-row gap-3">

                <button
                  onClick={() => handleSocialLogin("Google")}
                  className="btn btn-outline-secondary d-flex align-items-center justify-content-center"
                  style={{ flexGrow: 1 }}
                  disabled={loading}
                >
                  <i className="fab fa-google fs-4 py-1" />
                </button>

                <button
                  onClick={() => handleSocialLogin("Facebook")}
                  className="btn btn-outline-secondary d-flex align-items-center justify-content-center"
                  style={{ flexGrow: 1 }}
                  disabled={loading}
                >
                  <i className="fab fa-facebook-f fs-3 py-1" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>

      <ToastContainer />
    </>
  );
};

export default Login;
